import ConfirmDeleteSubcategoryModal from './ConfirmDeleteSubcategoryModal';

export default ConfirmDeleteSubcategoryModal;
